import { useState, type FunctionComponent } from "react";
import { NavLink } from "react-router-dom";
import { useUserStore } from "../store/user.store";
import FavouriteCreatorsIcon from "../assets/svgs/dashboard-sidebar/favourite-creators.svg";
import BrandsIcon from "../assets/svgs/dashboard-sidebar/brands.svg";
import ArrowBottomIcon from "../assets/svgs/common/arrow-bottom.svg";
import { AccountType } from "../constants/account-types.constants";
import LogoutIcon from "../assets/svgs/common/logout.svg";
import ProfileIcon from "../assets/svgs/common/profile.svg";
import WalletIcon from "../assets/svgs/dashboard-sidebar/wallet.svg";
import FavouriteIcon from "../assets/svgs/common/favourite.svg";
import CommunicationIcon from "../assets/svgs/dashboard-sidebar/communication.svg";
import { ScrollArea } from "./ui/scroll-area";
import HornIcon from "../assets/svgs/campaigns/horn.svg";
import LivePostsIcon from "../assets/svgs/dashboard-sidebar/live-posts.svg";

interface AppProps {
  // Mobile menu shows the logout option directly, without the name dropdown.
  alwaysShowLogout?: boolean;
}

export const DashboardSidebar: FunctionComponent<AppProps> = ({
  alwaysShowLogout = false,
}) => {
  const { user, logout } = useUserStore();
  const [dropMenuOpen, setDropMenuOpen] = useState(false);

  function HandleReturnMenu() {
    if (user?.accountType === AccountType.EPHEMERAL) {
      return [];
    }
    if (user?.accountType === AccountType.ADMIN) {
      return [
        {
          name: "Campaigns",
          icon: HornIcon,
          link: "/admin",
        },

        // {
        //   name: "Metric",
        //   icon: MetricIcon,
        //   link: "metric",
        // },
        {
          name: "Users",
          icon: ProfileIcon,
          link: "users",
        },
        {
          name: "Socials",
          icon: FavouriteCreatorsIcon,
          link: "socials",
        },
        // {
        //   name:"Vendors",
        //   icon: VendorIcon,
        //   link: "vendors",
        // },
        {
          name: "Brands",
          icon: BrandsIcon,
          link: "brands",
        },
        {
          name: "Payouts",
          icon: WalletIcon,
          link: "payouts",
        },
        {
          name: "Fixed payouts",
          icon: WalletIcon,
          link: "fixed-payouts",
        },
        {
          name: "Favorites",
          icon: FavouriteIcon,
          link: "favorites",
        },
        {
          name: "Communication",
          icon: CommunicationIcon,
          link: "communication",
        },
        {
          name: "Carousels",
          icon: LivePostsIcon,
          link: "carousels",
        },
        {
          name: "Wallet Transactions",
          icon: WalletIcon,
          link: "wallets/transactions/invoice-approval",
        },
        {
          name: "KYC Approvals",
          icon: ProfileIcon,
          link: "kyc-approvals",
        },
        {
          name: "Profile",
          icon: ProfileIcon,
          link: "profile",
        },
      ];
    }
  }

  return (
    <div className="flex flex-col justify-between bg-sidemenubg border-border border-r w-64 h-full">
      <div className="flex flex-col w-full h-full">
        <div className="flex items-center gap-2 pt-10 pb-9 pl-4 w-full">
          <img
            width={40}
            height={40}
            src="/static/profile.png"
            className="rounded-full"
            alt=""
          />
          <div className="flex flex-col">
            <p className="font-semibold text-secondary text-xs">Logged in as</p>
            {alwaysShowLogout ? (
              <p className="flex font-semibold">
                {user?.accountType === AccountType.EPHEMERAL && user?.name}
                {user?.accountType === AccountType.ADMIN && user?.name}
              </p>
            ) : (
              // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
              <p
                onClick={() => setDropMenuOpen(!dropMenuOpen)}
                className="flex font-semibold cursor-pointer"
              >
                {user?.accountType === AccountType.EPHEMERAL && user?.name}
                {user?.accountType === AccountType.ADMIN && user?.name}
                <span
                  className={
                    dropMenuOpen
                      ? "rotate-180 transition-all"
                      : "rotate-0 transition-all"
                  }
                >
                  <ArrowBottomIcon />
                </span>
              </p>
            )}
          </div>
        </div>
        <hr className="opacity-20" />
        {dropMenuOpen && !alwaysShowLogout ? (
          <div />
        ) : (
          <div className="flex flex-col h-full overflow-y-scroll">
            <ScrollArea>
              <div className="flex flex-col gap-8 py-10 pl-4 text-base">
                <ul className="flex flex-col space-y-9 text-secondary">
                  {HandleReturnMenu()?.map((menu, idx) => (
                    <NavLink
                      // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                      key={idx}
                      to={menu.link}
                      className={({ isActive }) =>
                        `flex items-center gap-2 font-semibold ${
                          isActive ? "text-primary" : "text-secondary"
                        }`
                      }
                      end
                    >
                      <menu.icon /> {menu.name}
                    </NavLink>
                  ))}
                </ul>
              </div>
            </ScrollArea>
          </div>
        )}
      </div>
      {dropMenuOpen || alwaysShowLogout ? (
        <div className="flex flex-col pb-12 pl-4 font-semibold">
          <ul className="flex flex-col gap-8">
            {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
            <li
              onClick={logout}
              className="flex gap-2 text-rejectbuttontext cursor-pointer"
            >
              <LogoutIcon /> Logout
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
};
